// Local translations for empty/error states
export const T = {
  en_GB: {
    completeRiskOrBuildCustom:
      "Please complete the risk assessment to see historical return data, or build a custom portfolio.",
    noProductsHistoricalReturn:
      "No products added yet. Use the Custom Portfolio Builder to add products, then historical return will be available.",
    enterInvestmentAmount: "Please enter an investment amount to see the historical return.",
    noPortfolioForScore: (score: string) =>
      `No portfolio available for risk score ${score}. Please contact your advisor to see your historical return.`,
    noPortfolioGeneric:
      "No portfolio available. Please contact your advisor to see your historical return.",
    notAvailable:
      "Historical return data is not available for this portfolio. This may be because the portfolio products are not linked to instruments with historical data. Please contact your advisor.",
    snapshotMissingMessage:
      "Historical return data needs to be regenerated. Use the Regenerate button above.",
    errorLoading: "Error loading historical return data. Please refresh the page.",
    unavailable: "Historical Return Data Unavailable",
  },
  nb_NO: {
    completeRiskOrBuildCustom:
      "Fullfør risikovurderingen for å se historisk avkastning, eller bygg en egendefinert portefølje.",
    noProductsHistoricalReturn:
      "Ingen produkter lagt til ennå. Bruk Egendefinert porteføljebygger for å legge til produkter, deretter vil historisk avkastning være tilgjengelig.",
    enterInvestmentAmount: "Angi et investeringsbeløp for å se historisk avkastning.",
    noPortfolioForScore: (score: string) =>
      `Ingen portefølje tilgjengelig for risikoskår ${score}. Kontakt din rådgiver for å se din historiske avkastning.`,
    noPortfolioGeneric:
      "Ingen portefølje tilgjengelig. Kontakt din rådgiver for å se din historiske avkastning.",
    notAvailable:
      "Historisk avkastningsdata er ikke tilgjengelig for denne porteføljen. Dette kan skyldes at porteføljeproduktene ikke er knyttet til instrumenter med historiske data. Kontakt din rådgiver.",
    snapshotMissingMessage:
      "Historisk avkastningsdata må regenereres. Bruk Regenerer-knappen over.",
    errorLoading: "Feil ved lasting av historisk avkastning. Oppdater siden.",
    unavailable: "Historisk avkastning ikke tilgjengelig",
  },
} as const;
